import React, { useState } from "react";
import { ErrorMessage } from "formik";
import { HiMiniEyeSlash, HiMiniEye } from "react-icons/hi2";
import styles from "./custominput.module.css";

const CustomInput = ({
  formType = "outline",
  isRequired = false,
  title,
  name,
  passwordToggle,
  placeholder,
  validate = true,
  ...rest
}) => {
  const [visible, setVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setVisible((prevState) => !prevState);
  };

  const inputType = passwordToggle ? (visible ? "text" : "password") : "text";

  return (
    <>
      {formType === "outline" && (
        <div className={styles.inputWrapper}>
          <label className={styles.title} htmlFor={rest?.id ?? name}>
            {title}
          </label>
          <div className={`has-pwd-icon ${passwordToggle ? "relative" : ""}`}>
            <input
              type={inputType}
              name={name}
              id={name}
              placeholder={placeholder ? placeholder : title}
              className={styles.textInput}
              {...rest}
            />
            {passwordToggle && (
              <div className="absolute inset-y-0 right-0 flex items-cener pr-2">
                {visible ? (
                  <HiMiniEye
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <HiMiniEyeSlash
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            )}
          </div>
          {validate && (
            <ErrorMessage
              name={name}
              component="div"
              className="text-red-500 text-[1.2rem] my-3"
            />
          )}
        </div>
      )}
      {formType === "flat" && (
        <div className={styles.flatInputWrapper}>
          <label className={styles.fillTitle} htmlFor={rest?.id ?? name}>
            {title}
          </label>
          <div className={`has-pwd-icon ${passwordToggle ? "relative" : ""}`}>
            <input
              type={inputType}
              name={name}
              id={name}
              placeholder={placeholder ? placeholder : title}
              className={styles.flatTextInput}
              {...rest}
            />
            {passwordToggle && (
              <div className="absolute inset-y-0 right-0 flex items-cener pr-2">
                {visible ? (
                  <HiMiniEye
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <HiMiniEyeSlash
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            )}
          </div>
          {validate && (
            <ErrorMessage
              name={name}
              component="div"
              className="text-red-500 text-[1.2rem] my-3"
            />
          )}
        </div>
      )}
      {formType === "fill" && (
        <div className={styles.fillInputWrapper}>
          <label className={styles.fillTitle} htmlFor={rest?.id ?? name}>
            {title}
            {isRequired && <span className="text-[#DD0808] pl-1">*</span>}
          </label>
          <div className={`has-pwd-icon ${passwordToggle ? "relative" : ""}`}>
            <input
              type={inputType}
              name={name}
              id={name}
              placeholder={placeholder ? placeholder : title}
              className={styles.fillTextInput}
              {...rest}
            />
            {passwordToggle && (
              <div className="absolute inset-y-0 right-0 flex items-cener pr-2">
                {visible ? (
                  <HiMiniEye
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <HiMiniEyeSlash
                    className={styles.viewPwd}
                    size={20}
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            )}
          </div>
          {validate && (
            <ErrorMessage
              name={name}
              component="div"
              className="text-red-500 text-[1.2rem] my-3"
            />
          )}
        </div>
      )}
    </>
  );
};

export default CustomInput;
